export default __webpack_public_path__ + "static/media/select-studio-cartoon-figure.3351ebd0.png";